import React, { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import SEO from '../components/SEO'
import { getShrimpPage } from './GuideShrimpData'

function Lightbox({ src, alt, onClose }) {
  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/70 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div className="max-w-6xl w-full" onClick={(e) => e.stopPropagation()}>
        <img src={src} alt={alt} className="w-full h-auto rounded-xl shadow-2xl" />
      </div>
    </div>
  )
}

function StepCard({ index, step, onPreview }) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div className="p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-dclaw-100 dark:bg-dclaw-900/30 text-dclaw-700 dark:text-dclaw-300 flex items-center justify-center font-bold">
            {index + 1}
          </div>
          <div className="flex-1">
            <p className="text-sm sm:text-base text-gray-700 dark:text-gray-200">{step.text}</p>
          </div>
        </div>
        {step.image && (
          <button type="button" onClick={() => onPreview(step.image, step.text)} className="mt-4 w-full">
            <img
              src={step.image}
              alt={step.text}
              className="w-full h-auto rounded-xl border border-gray-200 dark:border-gray-700"
              loading="lazy"
            />
          </button>
        )}
      </div>
    </div>
  )
}

export default function GuideShrimp() {
  const { slug } = useParams()
  const page = useMemo(() => getShrimpPage(slug), [slug])
  const [preview, setPreview] = useState(null)

  if (!page) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-8">
        <SEO title="如何养虾" description="如何养虾：OpenClaw 龙虾 AI 使用教程。" />
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">未找到页面</h2>
        <p className="text-gray-600 dark:text-gray-300 text-sm">请从左侧导航选择一个章节。</p>
      </div>
    )
  }

  return (
    <>
      <SEO title={page.title} description={`如何养虾：${page.title}`} />
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 sm:p-8">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">{page.title}</h2>
        {page.lead && <p className="text-gray-600 dark:text-gray-300 text-sm mb-6">{page.lead}</p>}

        <div className="grid gap-6">
          {page.steps.map((step, idx) => (
            <StepCard key={`${idx}-${step.image || ''}`} index={idx} step={step} onPreview={(src, alt) => setPreview({ src, alt })} />
          ))}
        </div>
      </div>

      {preview && <Lightbox src={preview.src} alt={preview.alt} onClose={() => setPreview(null)} />}
    </>
  )
}
